(function (window) {
    const NVZN3D_3DAPP_URL = "https://nvzn.io/player/";
    const NVZN3D_FLOORAPP_URL = "https://go.nvzn.io/floorapp/shared/player.html";
    const NVZN3D_ARTAPP_URL = 'https://art.nvzn.io';
    const APP_PRODUCT = {
        VERSION: "1.2.2",
        NAME: 'TRUEVIEW',
        HEADLINE: 'AR previews powered by Nvzn',
        CTA: 'Discover more at',
        LINK: 'https://nvzn.net',
        COLOR1: '#696AAB',
        COLOR2: '#9798CA',
    };

    async function _displayFloorPreview({
        clientId,       // nvzn client id
        imageUrl,       // url to source image
        width,          // width of object
        length,         // length of object
        units,          // unit of measurement
        shape,          // optional, shape of product
        allowScaling,   // optional, allow scaling
    } = {}) {
        const url = await _fetchFloorPreviewUrl({
            clientId,
            imageUrl,
            width,
            length,
            units,
            shape,
            allowScaling,
        });
        openModal(url, 'floor');
    }

    async function _displayArtPreview({
        clientId,          // required
        productId,          // required
        imageUrl,        // required
        width,              // required
        height,             // required
        units = 'in',       // optional, defaults to Inches
        language = 'en',    // optional, defaults to English
        tracking = false,   // optional, defaults to false
    } = {}) {
        const url = await _fetchArtPreviewUrl({
            clientId,
            productId,
            imageUrl,
            width,
            height,
            units,
            language,
        });
        openModal(url, 'wall');
    }

    async function _fetchFloorPreviewUrl({
        clientId,       // nvzn client id
        imageUrl,       // url to source image
        width,          // width of object
        length,         // length of object
        units,          // unit of measurement
        shape,          // optional, shape of product
        allowScaling,   // optional, allow scaling
    } = {}) {
        // validation
        if (!width || width <= 0) throw new Error(`[${APP_PRODUCT.NAME}] width is required`);
        if (!length || length <= 0) throw new Error(`[${APP_PRODUCT.NAME}] length is required`);
        units = units || 'cm';
        // build url
        let url = new URL(NVZN3D_FLOORAPP_URL);
        let params = new URLSearchParams();
        if (clientId) params.set('clientId', clientId);
        if (imageUrl) params.set('imageUrl', imageUrl);
        if (width) params.set('width', width);
        if (length) params.set('length', length);
        if (units) params.set('units', units);
        if (shape) params.set('shape', shape);
        if (allowScaling) params.set('allowScaling', allowScaling);
        url.search = params.toString();
        return url.toString();
    }

    async function _fetchArtPreviewUrl({
        clientId,           // required
        productId,          // required
        imageUrl,           // required
        width,              // required
        height,             // required
        units = 'in',       // optional, defaults to Inches
        language = 'en',    // optional, defaults to English
    } = {}) {
        // validation
        if (!clientId) throw new Error(`[${APP_PRODUCT.NAME}] clientId is required`);
        if (!productId) throw new Error(`[${APP_PRODUCT.NAME}] productId is required`);
        if (!imageUrl) throw new Error(`[${APP_PRODUCT.NAME}] imageUrl is required`);
        if (!width) throw new Error(`[${APP_PRODUCT.NAME}] width is required`);
        if (!height) throw new Error(`[${APP_PRODUCT.NAME}] height is required`);
        // build url
        const url = new URL(NVZN3D_ARTAPP_URL);
        let params = new URLSearchParams();
        if (clientId) params.set('a', clientId);
        if (productId) params.set('p', productId);
        if (imageUrl) params.set('i', imageUrl);
        if (width) params.set('w', width);
        if (height) params.set('h', height);
        if (units) params.set('u', units);
        if (language) params.set('l', language);
        url.search = params.toString();
        return url.toString();
    }

    function openModal(url, mode = 'floor') {
        if (!url) throw new Error(`[${APP_PRODUCT.NAME}] openModal requires url]`);
        const modal = document.createElement('div');
        modal.id = 'nvzn3d-modal';
        modal.classList.add('nvzn3d-modal');
        modal.dataset.mode = mode;
        modal.style.zIndex = 9999999999;
        modal.innerHTML = `
          <div class="nvzn3d-centered-container">
            <div id="nvzn3d-loader-container" class="nvzn3d-centered-container"><div class="nvzn3d-loading-spinner nvzn3d-centered-container"> </div></div>
            <svg id="nvzn3d-modal-close" class="nvzn3d-modal-close" viewBox="0 0 30 30">
              <circle cx="15" cy="15" r="14"></circle>
              <line x1="10" y1="10" x2="20" y2="20"></line>
              <line x1="20" y1="10" x2="10" y2="20"></line>
            </svg>
            <iframe id="nvzn3d-iframe" class="nvzn3d-iframe" src="" allow="xr-spatial-tracking *; clipboard-write *; fullscreen *; web-share;" allowfullscreen mozallowfullscreen webkitallowfullscreen></iframe>
          </div>
        `;
        document.body.style.overflow = 'hidden'; // lock background scroll
        modal.addEventListener('click', closeModal, { once: true });
        modal.querySelector('#nvzn3d-modal-close').addEventListener('click', closeModal, { once: true });
        window.addEventListener('keydown', handleEscape);
        modal.querySelector('#nvzn3d-iframe').addEventListener('load', () => {
            document.querySelector('#nvzn3d-loader-container').remove();
        });
        modal.querySelector('#nvzn3d-iframe').src = url;
        document.body.appendChild(modal);
    }

    function handleEscape(event) {
        if (event.key === 'Escape') {
            closeModal();
        }
    }

    function closeModal() {
        const modal = document.querySelector('#nvzn3d-modal');
        if (modal) {
            window.removeEventListener('keydown', handleEscape);
            document.body.style.overflow = '';
            modal.querySelector('#nvzn3d-iframe').src = 'about:blank';
            modal.style.display = 'none';
            modal.remove();
        }
    }

    function logProductSignature() {
        console.log(
            `%c ${APP_PRODUCT.NAME} %c ${APP_PRODUCT.HEADLINE} %c ${APP_PRODUCT.CTA} ${APP_PRODUCT.LINK}`,
            `background: ${APP_PRODUCT.COLOR1}; color: white; font-family: Tahoma, sans-serif; font-weight: bold; padding: 4px 6px 4px 10px; border-radius: 20px 0 0 20px; white-space: nowrap;`,
            `background: ${APP_PRODUCT.COLOR2}; color: white; font-family: Tahoma, sans-serif; font-weight: normal; padding: 4px 10px 4px 6px; border-radius: 0 20px 20px 0; margin-right: 12px; white-space: nowrap;`,
            `color: #525252; font-family: Tahoma, sans-serif; font-weight: normal; font-size: 0.8em; white-space: nowrap;`
        );
    }

    // Public API
    const Nvzn3D = {
        getVersion: function () {
            return APP_PRODUCT.VERSION;
        },
        displayArtPreview: function (config) {
            return _displayArtPreview(config);
        },
        displayFloorPreview: function (config) {
            return _displayFloorPreview(config);
        },
    };
    // Expose API globally
    window.Nvzn3D = Object.freeze(Nvzn3D);
    logProductSignature();

})(window);
